import { createApp } from 'vue';
import FrameOnlyAddToCart from '../components/frameOnly/FrameOnlyAddToCart';

function frameOnlyAddToCart() {
  const $mount = document.querySelector('#frameOnlyAddToCart');

  if (!$mount) return;

  const app = createApp(FrameOnlyAddToCart, {
    productId: $mount.dataset.productId,
    variantId: $mount.dataset.variantId,
    facePaperUrl: $mount.dataset.facePaperUrl,
    available: $mount.dataset.available === 'true',
    price: $mount.dataset.price,
  });

  app.mount($mount);
}

export default frameOnlyAddToCart;
